module.exports = __webpack_public_path__ + "img/arrow_head_left_b.e1f1a392.svg";